


const questions = document.getElementsByClassName("faq_accordion");
const answers = document.getElementsByClassName("faq_panel");
const faqBtns = document.getElementsByClassName("faq_button");


setDefault();


for (let question of questions) {
	question.addEventListener('click', openCurrentQuestion);
}

for (let btn of faqBtns) {
	btn.addEventListener('click', handleFaqSwitch);
}

for (let btn of faqBtns) {
	btn.addEventListener('mouseenter', handleHover);
}



function openCurrentQuestion(e) {
  let activator;
  
  e.target.classList.contains('faq-expand') ? 
    activator = e.target.parentElement.parentElement : 
  	activator = e.target;

  
  if (!activator.classList.contains('active')) {
   
  for (let question of questions) {
    for (answer of answers) {
  	question.classList.remove('active');
    answer.classList.remove('expanded');
    }
  }

  activator.classList.add('active');
  activator.nextElementSibling.classList.add('expanded');
  
}
else {
	activator.nextElementSibling.classList.remove('expanded');
	activator.classList.remove('active');
  	
}
   
}



function setDefault() {
	document.getElementById('orders').classList.add('active');
  	document.getElementById('faq-btn-orders').classList.add('active');
}




function handleFaqSwitch(e) {
  
  if (!e.target.classList.contains('active')) {
  
  for (btn of faqBtns) {
  	btn.classList.remove('active');
  }
  
  e.target.classList.add('active');
  
  let faqName = e.target.textContent.trim().toLowerCase(); 
  let faqBodyId;
  
  let faqContentBlocks = document.querySelectorAll('.faq-content');
  
  for (block of faqContentBlocks) {
  	block.classList.remove('active');
  }
  
  for (question of questions) {
  	question.classList.remove('active');
  }
  for (answer of answers) {
  	answer.classList.remove('expanded');
  }
  
  
  switch(faqName) {
    case "orders":
      faqBodyId = "orders";
      break;
    case "allergens & dietary":
      faqBodyId = "allergens";
      break;
    case "cake storage" :
      faqBodyId = "storage";
      break;
    case "contact" :
      faqBodyId = "contact"; 
      break;
    default: 
      faqBodyId = "orders";
  }
  
  document.getElementById(faqBodyId).classList.add('active');

  }
  return;
}


function handleHover(e) {
  
  if (!e.target.classList.contains('active')){  
e.target.classList.add('hover');
  e.target.addEventListener('mouseleave', (e) => {  
	e.target.classList.remove('hover');
})
  }
  else return;
}


